import hindi from "./hindi";
export const languages = {
    hindi
};
export const language = (lang="english")=>(
    (key,lan=lang)=>(lan=="english")?key:(languages[lan][key]||key)
)